// 初回ログイン時のガイダンスのフェーズ
const GUIDE_PHASE = {
  // 中心座標登録
  GUIDE_ADD_HOME_MARKER: 0,
  // 田圃登録紹介
  GUIDE_PADDY_FIELD_ADD: 1,
  // 作業項目紹介
  GUIDE_WORKITEM_EDIT: 2,
  // ガイダンス終了
  GUIDE_FINISHED: 999
};

// メッセージダイアログの種類
const DIALOG_TYPE = {
  MESSAGE: 1,
  CONFIRM: 2
};

// key
const PAYMENT = {
  KEY: "pk_live_18e8ee952a741311e2c7e57f",
};
// 処理結果
const PAYMENT_RESULT_CODE = {
  Success : "0",
  Already : "1",
  Retry : "2",
  Error: "9",
};

const MENU_CODE = {
  DASHBOARD: "01",
  PADDY_FIELD_MAP: "02",
  WORK_INPUT: "03",
  ARCHIVE_WORK_PADDY: "04",
  ARCHIVE_WORK_NOTPADDY: "05",
  ARCHIVE_INFORMATION: "06",
  ARCHIVE_WORK_LOG: "07",
  ARCHIVE_WEATHER: "08",
  ARCHIVE_WATER_GATE_LOG: "09",
  SETTING_PADDY_FIELD_ADD: "10",
  SETTING_PADDY_FIELD_EDIT: "11",
  SETTING_BRAND: "12",
  SETTING_WORK_ITEM: "13",
  SETTING_WEATHER: "14",
  SETTING_USER: "15",
  SETTING_HOME: "16",
  SETTING_LANDMARK: "17",
  SETTING_PERSONAL: "18",
  PAYMENT: "19",
  HISTORY: "20",
  INQUIRY: "21",
  WATER: "22",
  WATER_GATE: "23",
  SETTING_PADDY_FIELD: "24",
  SENSOR: "25",
  SENSOR_SETTING: "26",
  SENSOR_ALERT: "27",
  ARCHIVE_SENSOR: "28",
  CARD_CHANGE: "29",
};
const OPERATION_TYPE = {
  Menu: "0",
  Insert: "1",
  Update: "2",
  Delete: "3",
};

export { GUIDE_PHASE, DIALOG_TYPE, PAYMENT, PAYMENT_RESULT_CODE, MENU_CODE, OPERATION_TYPE };
